import { factory, am } from './utils';

import httpClient from '@/utils/httpClient';

const GET_COMMENTS = am('GET_COMMENTS');
const ADD_COMMENT = am('ADD_COMMENT');
const ADD_COMMENT_ATTACHMENT = am('ADD_COMMENT_ATTACHMENT');

export default {
  namespaced: true,
  ...factory({
    state: {
      collection: {},
      total: 0,
      isGetCommentsRequestPending: false,
      isGetCommentsRequestFailed: false,
      isAddCommentRequestPending: false,
      isAddCommentRequestFailed: false
    },
    mutations: {
      [GET_COMMENTS.STARTED](state) {
        state.isGetCommentsRequestFailed = false;
        state.isGetCommentsRequestPending = true;
        if (!state.collection?.data) {
          state.collection = { data: [] };
        }
      },
      [GET_COMMENTS.COMPLETED](state, { collection, page }) {
        state.total = collection.meta.pagination.total;
        state.isGetCommentsRequestPending = false;
        if (page === 1) {
          state.collection = collection;
        } else {
          state.collection = {
            ...collection,
            data: [...state.collection.data, ...collection.data]
          };
        }
      },
      PULL_NEW_COMMENTS(state, items) {
        if (!Array.isArray(items) || !items.length) return;
        const existingIds = new Set(state.collection.data.map(item => item.id));
        const filtered = items.filter(item => !existingIds.has(item.id));
        state.collection.data.unshift(...filtered);
        state.total += filtered.length;
        state.collection.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      },
      [GET_COMMENTS.FAILED](state) {
        state.isGetCommentsRequestFailed = true;
        state.isGetCommentsRequestPending = false;
      },
      [ADD_COMMENT.STARTED](state) {
        state.isAddCommentRequestPending = true;
        state.isAddCommentRequestFailed = false;
      },
      [ADD_COMMENT.COMPLETED](state, item) {
        state.collection.data.unshift(item);
        state.total = state.total + 1;
        state.isAddCommentRequestPending = false;
      },
      [ADD_COMMENT.FAILED](state) {
        state.isAddCommentRequestPending = false;
        state.isAddCommentRequestFailed = true;
      },
      [ADD_COMMENT_ATTACHMENT.STARTED](state) {
        state.isAddCommentRequestPending = true;
        state.isAddCommentRequestFailed = false;
      },
      [ADD_COMMENT_ATTACHMENT.COMPLETED](state, item) {
        state.collection.data.push(item);

        state.isAddCommentRequestPending = false;
      },
      [ADD_COMMENT_ATTACHMENT.FAILED](state) {
        state.isAddCommentRequestPending = false;
        state.isAddCommentRequestFailed = true;
      }
    },
    actions: {
      async getComments({ commit }, { minionId, page = 1 }) {
        try {
          commit(GET_COMMENTS.STARTED);
          const collection = await httpClient.get(
            `/api/settings/minion-dojo-api/api/comments?populate=*&filters[minionId][$eq]=${minionId}&pagination[page]=${page}&pagination[pageSize]=25&sort=createdAt:desc`
          );

          commit(GET_COMMENTS.COMPLETED, { collection, page });
        } catch (e) {
          commit(GET_COMMENTS.FAILED);
          throw e;
        }
      },
      async pullNewComments({ commit }, { minionId }) {
        try {
          const response = await httpClient.get(
            `/api/settings/minion-dojo-api/api/comments?populate=*&filters[minionId][$eq]=${minionId}&sort=createdAt:desc&pagination[page]=1&pagination[pageSize]=25`
          );

          const newComments = Array.isArray(response.data) ? response.data : [];
          commit('PULL_NEW_COMMENTS', newComments);
        } catch (e) {
          console.error('pullNewComments error', e);
        }
      },
      async add({ commit }, item) {
        try {
          commit(ADD_COMMENT.STARTED);

          const response = await httpClient.post(`/api/settings/minion-dojo-api/api/comments`, { data: { ...item } });

          const posted = response?.data;
          if (!posted?.id) {
            throw new Error(`Failed to add new comment with contents: ${item.content}`);
          }

          const hasAttachments = Array.isArray(item.attachments) && item.attachments.length > 0;

          if (hasAttachments) {
            const newComment = await httpClient.get(`/api/settings/minion-dojo-api/api/comments/${posted.documentId}?populate=*`);
            commit(ADD_COMMENT.COMPLETED, newComment.data);
          } else {
            commit(ADD_COMMENT.COMPLETED, posted);
          }
        } catch (e) {
          commit(ADD_COMMENT.FAILED);
          throw e;
        }
      },
      async attAttachment({ commit }, { id }) {
        try {
          commit(ADD_COMMENT_ATTACHMENT.STARTED);

          // const response = await httpClient.delete(`/api/minion-dojo-api/api/minions${id}`);

          // if (response.status !== 204) {
          //   throw new Error(`Failed to delete item with id: ${id}`);
          // }

          commit(ADD_COMMENT_ATTACHMENT.COMPLETED, { id });
        } catch (e) {
          commit(ADD_COMMENT_ATTACHMENT.FAILED);
          throw e;
        }
      }
    }
  })('comments')
};
